<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- TÍTULO -->
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        list
                    </mat-icon>
                    <span class="logo-text h1">
                        Comissionamento {{ title }}
                    </span>
                </div>
                <!-- / TÍTULO -->

                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Exportar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Exportar Comissionamento"
                            (click)="export()"
                            *ngIf="_authService.isPermissao(['Exportar Importação de Comissionamento Secundário'])">
                        <mat-icon>cloud_download</mat-icon>
                    </button>

                    <!-- Botão Upload -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Upload de Arquivo"
                            (click)="openCadastro()"
                            *ngIf="_authService.isPermissao(['Upload da Importação Secundário'])">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                </div>
                <!-- / BOTÕES DE AÇÃO -->
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material striped' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'
                [limit]="params.per_page"
                (sort)="onSort($event)">
                
               <ngx-datatable-column 
                    name="Data" 
                    prop="date_operation" 
                    [sortable]="true"                     
                >
                    <ng-template 
                        let-rowIndex="rowIndex" 
                        let-row="row" 
                        ngx-datatable-cell-template
                    >
                        <span hide="true"> 
                            {{row.date_operation | date:'dd/MM/yyyy'}}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Cliente" 
                    prop="cliente" 
                    [sortable]="true"                   
                >
                    <ng-template 
                        let-rowIndex="rowIndex" 
                        let-row="row" 
                        ngx-datatable-cell-template
                    >
                        <span style="text-transform: uppercase">
                            {{ row.cliente_conta + ' - ' +  row.cliente_nome}}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Assessor" 
                    prop="usuario" 
                    [sortable]="true" 
                    *ngIf="user.role_id == 2 || user.role_id == 7 || user.role_id == 10"                    
                >
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.assessor_nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Escritório" 
                    prop="escritorio" 
                    [sortable]="true" 
                    *ngIf="user.role_id == 2 || user.role_id == 7 || user.role_id == 10"                    
                >
                    <ng-template 
                        let-rowIndex="rowIndex" 
                        let-row="row" 
                        ngx-datatable-cell-template
                    >
                        {{row.escritorio_nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Produto" 
                    prop="produto_id" 
                    [sortable]="true"
                >
                    <ng-template 
                        let-rowIndex="rowIndex" 
                        let-row="row" 
                        ngx-datatable-cell-template 
                    >
                        {{row.produto_nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Ativo" 
                    prop="produto_ativo_id" 
                    [sortable]="true"                    
                >
                    <ng-template 
                        let-rowIndex="rowIndex" 
                        let-row="row" 
                        ngx-datatable-cell-template 
                    >
                        {{row.ativo_nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Volume Financeiro" 
                    prop="financial_volume" 
                    [sortable]="true" 
                    *ngIf="user.role_id == 2 || user.role_id == 7 || user.role_id == 10"                    
                >
                    <ng-template 
                        let-rowIndex="rowIndex"                         
                        let-row="row" 
                        ngx-datatable-cell-template
                    >
                        <span hide="true"> R$ {{row.financial_volume | number : '1.2-2'}}</span>
                    </ng-template>
                  
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Receita Bruta (a dividir)" 
                    prop="commission" 
                    [sortable]="true"                     
                >
                    <ng-template 
                        let-rowIndex="rowIndex" 
                        let-row="row" 
                        ngx-datatable-cell-template
                    >
                        <span hide="true"> R$ {{row.commission | number : '1.2-2'}}</span>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>
            
            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>